interface CohortEditModalSkeletonProps {
  loadingLabel?: string | null;
}

export const CohortEditModalSkeleton = ({ loadingLabel }: CohortEditModalSkeletonProps) => {
  return (
    <div className="animate-pulse space-y-4" aria-busy="true" aria-live="polite">
      <span className="sr-only">{loadingLabel ?? 'Loading cohort details...'}</span>
      <div className="space-y-2">
        <div className="h-4 w-24 rounded bg-gray-300" />
        <div className="h-10 w-full rounded-lg bg-gray-200" />
      </div>
      <div className="space-y-2">
        <div className="h-4 w-20 rounded bg-gray-300" />
        <div className="h-10 w-full rounded-lg bg-gray-200" />
      </div>
      <div className="space-y-2">
        <div className="h-4 w-16 rounded bg-gray-300" />
        <div className="h-10 w-full rounded-lg bg-gray-200" />
      </div>
      <div className="flex justify-end gap-3 pt-2">
        <div className="h-10 w-24 rounded-lg bg-gray-200" />
        <div className="h-10 w-24 rounded-lg bg-gray-300" />
      </div>
    </div>
  );
};
